module.exports = __webpack_public_path__ + "img/dcu30-1.9a39e73e.png";